// extracted by mini-css-extract-plugin
export default {"tracing":"Waveform_tracing__zVJ3N"};